var _defs, _g, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChorme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x2: 1,
    gradientTransform: "matrix(25.118 43.506 -43.506 25.118 25.812 45.935)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32a651",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#279847",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x2: 1,
    gradientTransform: "matrix(61.286 0 0 61.286 29.399 42.333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#db3328",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e53d30",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5744 96h0.00446v-0.0078h-0.00446z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.5744 96h0.00446v-0.0078h-0.00446z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0583 0 0 -1.0583 0 135.47)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5789 95.992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4e-3 8e-3z",
    fill: "#d663ff"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.5789 95.992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-4e-3 8e-3z",
    fill: "#9963ff"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m67.733 67.733 29.33 16.933-29.33 50.8c37.408 0 67.733-30.325 67.733-67.733 0-12.341-3.3168-23.901-9.0837-33.867h-58.65z",
    fill: "#fbbf12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m67.733-1e-6c-25.07 0-46.942 13.63-58.654 33.875l29.324 50.792 29.33-16.933v-33.867h58.65c-11.714-20.24-33.583-33.867-58.65-33.867z",
    fill: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m0 67.733c0 37.408 30.324 67.733 67.733 67.733l29.33-50.8-29.33-16.933-29.33 16.933-29.324-50.792c-5.7637 9.9632-9.0794 21.519-9.0794 33.858",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m101.6 67.733c0 18.704-15.163 33.867-33.867 33.867-18.704 0-33.867-15.163-33.867-33.867s15.163-33.867 33.867-33.867c18.704 0 33.867 15.163 33.867 33.867",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m95.25 67.733c0 15.197-12.32 27.517-27.517 27.517-15.197 0-27.517-12.32-27.517-27.517 0-15.197 12.32-27.517 27.517-27.517 15.197 0 27.517 12.32 27.517 27.517",
    fill: "#1a73e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChorme);
export default __webpack_public_path__ + "static/media/chorme.b0bd08e3d4226484ce842d3453b979e9.svg";
export { ForwardRef as ReactComponent };